// extracted by mini-css-extract-plugin
export default {"wrapper":"BundleDescriptionSkeleton_wrapper","line":"BundleDescriptionSkeleton_line","half":"BundleDescriptionSkeleton_half","skeleton":"BundleDescriptionSkeleton_skeleton"};